import React, { useState, useRef } from "react";
import Modal from "react-modal";
import { setIsOpen } from "react-modal";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  GoogleLogin,
  GoogleOAuthProvider,
  useGoogleLogin,
  useGoogleOneTapLogin,
} from "@react-oauth/google";
import { getGoogleAPIClientID } from "../../common/services/config";

import { performGoogleLogin } from "../../common/actions/userAccount/RegistrationAction";
import axios from "axios";

const GoogleLoginButton = React.forwardRef((props, ref) => {
  const login = useGoogleOneTapLogin({
    onSuccess: async credentialResponse => {
      console.log("======credentialResponse======>",credentialResponse);
      props.doPerformGoogleLogin({
        idToken: credentialResponse.credential,
      });
      // fetching userinfo can be done on the client or the server
     
    },
    onError: () => {
      console.log('Login Failed');
    },
   // flow: 'implicit', // implicit is the default
    });

  return <button type="button" onClick={(event) => login()}>Sign in with Google</button>;
});

GoogleLoginButton.displayName = "GoogleLoginButton";
function mapStateToProps(state) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {
    doPerformGoogleLogin: (data) => dispatch(performGoogleLogin(data)),
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
  })(GoogleLoginButton)
);
